import { Flex } from "@chakra-ui/react";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useParams } from "react-router-dom";

import { getStore } from "../../actions/storesActions";
import LoadingPlaceholder from "../../components/LoadingPlaceholder";
import StoreData from "./StoreData";
import StoreFooter from "./StoreFooter";

const StoreScreen = () => {
  const { slug } = useParams();
  const dispatch = useDispatch();
  const { loading, store, error } = useSelector((state) => state.storeScreen);

  useEffect(() => {
    dispatch(getStore(slug));
  }, [slug, dispatch]);

  if (error) return <Redirect to="/404" />;
  if (loading) return <LoadingPlaceholder minH='100vh' />;
  return (
   <>
      <Helmet>
        <title>{store.name}</title>
        <meta name="description" content={store.description} />
      </Helmet>
      <Flex 
        flexDir={"column"}
        minH='100vh'
        flex={1} justifyContent="space-between" alignItems="center" w="100%"
      >
          <StoreData store={store} />
          <div style={{width: '100%', height: '100px'}}></div>
          <StoreFooter store={store} />
      </Flex>
    </>
  );
};

export default StoreScreen;
